import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function FirstEventBooking() {
    return (
        <section className="space-y-10">

            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold mb-2">First Event Booking</h1>
                <p className="text-slate-600">
                    This guide walks you through creating your very first booking in
                    EventFlow, helping you understand the complete booking lifecycle.
                </p>
            </section>

            <section className="bg-white border-l border-[#C9A24E] p-8 rounded-lg">
                <h2 className="text-lg font-semibold mb-3">Overview</h2>
                <p className="text-slate-600 text-sm">
                    EventFlow follows a structured flow from estimation to confirmation,
                    payment tracking, and calendar visibility.
                </p>
            </section>

            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 1: Create an Estimate</h3>
                <p className="text-slate-600">
                    Start by preparing an event estimate that defines guest count,
                    services, and expected pricing for the customer.
                </p>
            </section>

            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 2: Confirm the Booking</h3>
                <p className="text-slate-600">
                    Convert the estimate into a confirmed booking by assigning event
                    date, slot, hall portion, and organizer details.
                </p>
            </section>

            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 3: Record Payments</h3>
                <p className="text-slate-600">
                    Record advance payments and verify that balances are calculated
                    correctly.
                </p>
            </section>

            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Step 4: Verify Calendar Entry</h3>
                <p className="text-slate-600">
                    Ensure the booking appears correctly in the event calendar,
                    preventing double bookings.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, explore{" "}
                    <Link to="/docs/admin-dashboard" className="font-medium text-[#C9A24E]">
                        Core Features
                    </Link>{" "}
                    of EventFlow.
                </p>
            </section> */}
   <DocNavigation
                previous={{
                    title: "Initial Setup",
                    link: "/docs/initial-setup"
                }}
                next={{
                    title: "Dashboard",
                    link: "/docs/admin-dashboard"
                }}
            />
        </section>
    );
}
